$(document).ready(function() {
    var href = window.location.href;
    var lang = $('html').attr('lang').substring(0,2);
    var epdmPrd = [
        "ZVZX1015-P",
        "ZVZX1320-S",
        "ZVZX1011-P",
        "ZVZX1211-P",
        "ZVZX1222-P",
        "ZVZX1231-P",
        "ZVZX1241-P",
        "ZVZX1310-P1M",
        "ZVZX1310-60S",
        "ZWPX2184-P",
        "ZWPX2197-S",
        "ZWPX2180-P",
        "ZWPX2185-P",
        "ZWPX2194-P",
        "ZWPX2196-S",
        "ZWPX2182-P",
        "ZWPX2195-S",
        "ZVZX2194-P",
        "ZVZX2196-P",
        "ZVZX2180-P",
        "ZVZX2185-P"

    ];
    var isEPDMPrdPage =
        href.indexOf("/products/") > -1
        && epdmPrd.indexOf($("span.variant-sku").text()) > -1;
    var isLandingPage = href.indexOf("/pages/") > -1 && $(".elfsight-app-0c9e298e-ebc4-4e51-b924-e287d5c9c6c0").length;

    if (isEPDMPrdPage) {

        var prepareCalcAwareness = function (waitElement) {
            waitForElementToDisplay(waitElement,
                function() {
                    if ($("[class^=ButtonBase__Ellipsis-sc]").length) {

                        $("[class^=ButtonBase__Ellipsis-sc]").on("click", function(event) {
                            event.preventDefault();
                            var count = $("[class^=animated-number__Content-sc]").text().split("m²")[0];
                            var sku = $("span.variant-sku").text();
                            switch(sku) {
                                case "ZVZX1011-P":
                                    count = Math.ceil(count / 2);
                                    break;
                                case "ZVZX1211-P":
                                    count = Math.ceil(count / 3);
                                    break;
                                case "ZVZX1222-P":
                                    count = Math.ceil(count / 4);
                                    break;
                                case "ZVZX1231-P":
                                    count = Math.ceil(count / 5);
                                    break;
                                case "ZVZX1241-P":
                                    count = Math.ceil(count / 6);
                                    break;
                                case "ZVZX1015-P":
                                    count = Math.ceil(count / 0.66);
                                    break;
                                case "ZVZX1215-P":
                                    count = Math.ceil(count / 0.99);
                                    break;
                                case "ZVZX1225-P":
                                    count = Math.ceil(count / 1.32);
                                    break;
                                case "ZVZX1235-P":
                                    count = Math.ceil(count / 1.65);
                                    break;
                                case "ZVZX1245-P":
                                    count = Math.ceil(count / 1.98);
                                    break;
                                case "ZVZX1310-P1M":
                                    count = Math.ceil(count / 0.15);
                                    break;
                                case "ZVZX1310-60S":
                                    count = Math.ceil(count / 9);
                                    break;

                            }
                            $(".price-per-item__container .quantity__input").val(count);
                        });

                        $("[class^=EmbedRoot__Root-sc] > a").remove();
                    }
                },1000,9000
            );
        };
        prepareCalcAwareness(".elfsight-app-0c9e298e-ebc4-4e51-b924-e287d5c9c6c0 button");

        // in case a product is not directly an EPDM solar panel but an accessory, we prepare the EPDm calculator in a feasible solar panel upsell
        var prepareEPDMupsell = function (waitElement) {
            waitForElementToDisplay(waitElement,
                function() {
                    $(".lb-spc-details-name").each( function() {
                        text = $(this).text().trim();
                        if (text.indexOf('EPDM')!== -1) {
                            $(this).closest(".lb-spc-cont").append(
                                '<script src="https://static.elfsight.com/platform/platform.js" async></script>\n' +
                                '<div class="elfsight-app-0c9e298e-ebc4-4e51-b924-e287d5c9c6c0" style="display:none;" data-elfsight-app-lazy></div>'
                            );
                            $(this).closest(".lb-spc-cont").addClass("epdm-upsell");
                        }
                    });
                },1000,9000
            );
        };
        prepareEPDMupsell(".lb-upsell-ppa-card-cont");

        // Change the amount label to surface in sqm
        if ($("span.variant-sku").text() === "ZVZX1320-S") {
            $(".product-form__input.product-form__quantity label").text("Oppervlakte in m²");
        }
    }

    $("#calculator-accordion").accordion();
    $("#calculator-accordion").accordion("enable");
    $("#calculator-accordion").accordion({collapsible: true, active: false});
    $("#calculator-accordion").css({"display": "block"});
    if (href.indexOf("/products/") > -1) {
        try {
            // enable accordion sections in product description
            var totalSibs = $(".product__description").children().length;
            var totalH3 = $(".product__description > h3").length;
            var totalDiv = $(".product__description > div").length;
            if (totalH3 + totalDiv == totalSibs) {
                $(".product__description").accordion({
                    header: function (accordionElement) {
                        return accordionElement.find("h3");
                    }
                });
                $(".product__description").accordion();
                $(".product__description").accordion("enable");
            }
        } catch (e) {
            console.log("accordion function is not defined");
        }
    }
    if (isEPDMPrdPage) {
        try {
            $("#calculator-accordion").css({"display": "none"});
            $("#calculator-accordion").accordion();
            $("#calculator-accordion").accordion("enable");
            $("#calculator-accordion").accordion({collapsible: true, active: false});
            $("#calculator-accordion").css({"display": "block"});
        } catch (e) {
            console.log("accordion function is not defined");
        }
    }

    if (isLandingPage) {
        // remove epdm calculator branding
        var removeBranding = function (waitElement) {
            waitForElementToDisplay(waitElement,
                function() {
                    $(".EmbedRoot__Root-sc-1c4b4pg-0 > a").remove();
                },500,9000
            );
        };
        removeBranding(".EmbedRoot__Root-sc-1c4b4pg-0");
    }

    if (lang !== "nl" && (isLandingPage || isEPDMPrdPage)) {
        // translate literals
        var literals = {
            "Oppervlakte zwembad": {
                fr: "Surface de piscine",
                pt: "Superfície da piscina",
                de: "Oberfläche des Schwimmbades",
                es: "Superficie de piscina"
            },
            "Land": {
                fr: "Pays",
                pt: "Pais",
                de: "Land",
                es: "País"
            },
            "Gebruik de slider om  je zwembadoppervlakte in te stellen": {
                fr: "Utilisez le curseur pour définir votre surface de piscine",
                pt: "Utilize o controlo deslizante para definir a área da sua piscina",
                de: "Mit dem Schieberegler legen Sie Ihren Poolbereich fest",
                es: "Utilice el control deslizante para configurar el área de su piscina"
            },
            "Selecteer land van installatie": {
                fr: "Choisir le pays d'installation",
                pt: "Selecione o país de instalação",
                de: "Wählen Sie das Land der Installation",
                es: "Seleccione país de instalación"
            },
            "Aanbevolen EPDM oppervlakte": {
                fr: "Surface EPDM recommandée",
                pt: "Superfície EPDM recomendada",
                de: "Empfohlene EPDM-Oberfläche",
                es: "Superficie EPDM recomendada"
            },
            'De berekening is gebaseerd op een <strong>30° zuiderhelling, 1,5m baddiepte met afdekzeil.</strong><br>Download onze uitgebreide calculator <a target="_blank" rel="nofollow" href="https://cdn.shopify.com/s/files/1/0807/2649/1484/files/Turbocalculator_EPDM_EN.xls?v=1736058367"><strong>hier</strong></a>': {
                fr: 'Le calcul est basé sur une <strong>pente orientée sud de 30° et une profondeur de piscine de 1,5 m avec couverture.</strong><br>Téléchargez notre calculateur détaillé <a target="_blank" rel="nofollow" href="https://cdn.shopify.com/s/files/1/0807/2649/1484/files/Turbocalculator_EPDM_EN.xls?v=1736058367"><strong>ici</strong></a>',
                pt: 'O cálculo baseia-se numa inclinação de <strong>30° virada a sul, profundidade de piscina de 1,5 m com cobertura.</strong><br>Descarregue a nossa extensa calculadora <a target="_blank" rel=" nofollow" href="https://cdn.shopify.com/s/files/1/0807/2649/1484/files/Turbocalculator_EPDM_EN.xls?v=1736058367"><strong>aqui</strong></a>',
                de: 'Die Berechnung basiert auf einem <strong>30° Südhang, 1,5m Beckentiefe mit Abdeckung.</strong><br>Laden Sie unseren umfangreichen Rechner herunter <a target="_blank" rel="nofollow" href="https://cdn.shopify.com/s/files/1/0807/2649/1484/files/Turbocalculator_EPDM_EN.xls?v=1736058367"><strong>hier</strong></a>',
                es: 'El cálculo se basa en una <strong>pendiente de 30° orientada al sur y una piscina de 1,5 m de profundidad con cubierta.</strong><br>Descargue nuestra extensa calculadora <a target="_blank" rel="nofollow" href="https://cdn.shopify.com/s/files/1/0807/2649/1484/files/Turbocalculator_EPDM_EN.xls?v=1736058367"><strong>aquí</strong></a>'
            },
            "Jaarlijkse energiebesparing op uw warmtepomp": {
                fr: "Économies d'énergie annuelles sur votre pompe à chaleur",
                pt: "Poupança anual de energia na sua bomba de calor",
                de: "Jährliche Energieeinsparungen bei Ihrer Wärmepumpe",
                es: "Ahorro energético anual en tu bomba de calor"
            },
            "Terugverdientijd": {
                fr: "Période de remboursement",
                pt: "Período de retorno",
                de: "Amortisationsdauer",
                es: "Periodo de recuperación"
            },
            "jaar": {
                fr: "années",
                pt: "anos",
                de: "Jahre",
                es: "años"
            },
            "Kopieer naar bestelling": {
                fr: "Copier vers commande",
                pt: "Copiar para encomendar",
                de: "Zur Bestellung kopieren",
                es: "Copiar para ordenar"
            },
            "Toename badwater °C": {
                fr: "Augmentation °C eau du bain",
                pt: "Aumento °C da água do banho",
                de: "°C Anstieg des Badewassers",
                es: "Aumento °C del agua del baño"
            },
            "We adviseren een installatie die een gemiddelde temperatuurstijging van 5°C behaalt": {
                fr: "Nous recommandons une installation qui atteint une augmentation de la température moyenne de 5°C",
                pt: "Recomendamos uma instalação que consiga um aumento médio de temperatura de 5°C",
                de: "Wir empfehlen eine Installation, die eine durchschnittliche Temperaturerhöhung von 5°C erreicht",
                es: "Recomendamos una instalación que consiga un aumento de temperatura medio de 5°C"
            },
            "Oppervlakte in m²": {
                fr: "Superficie en m²",
                pt: "Área em m²",
                de: "Fläche in m²",
                es: "Superficie en m²"
            },
            "Beschrijf de totale hoogte x breedte van uw gewenste EPDM zonnecollector. Geef als breedte steeds een veelvoud van 33.3 cm.": {
                fr: "Décrivez la hauteur x la largeur totale du capteur solaire EPDM souhaité. Spécifiez toujours un multiple de 33,3 cm pour la largeur.",
                pt: "Descreva a altura x largura total do coletor solar de EPDM pretendido. Especifique sempre um múltiplo de 33,3 cm para a largura.",
                de: "Beschreiben Sie die Gesamthöhe x Breite Ihres gewünschten EPDM-Solarkollektors. Geben Sie bei der Breite immer ein Vielfaches von 33,3 cm an.",
                es: "Describe la altura x ancho total del colector solar EPDM deseado. Especifique siempre un múltiplo de 33,3 cm para el ancho."
            },
            "Hoogte X Breedte EPDM installatie": {
                fr: "Installation EPDM hauteur x largeur *",
                pt: "Instalação de EPDM Altura X Largura *",
                de: "Höhe X Breite EPDM-Installation *",
                es: "Instalación de EPDM Alto X Ancho *"
            }
    };

        var translateLiterals = function (waitElement, event) {
            waitForElementToDisplay(waitElement,
                function() {
                    var text = ""; var textInner ="";
                    var translation ="";
                    $(".form__Container-sc-de90c04-0 label").each( function() {
                        text = $(this).text().trim();
                        try {
                            translation = literals[text][lang];
                        }
                        catch (err) {
                            //not found
                            translation = text;
                        }
                        $(this).text(translation);
                    });
                    $("[class^=FormFieldLayout__Label-sc]").each( function() {
                        text = $(this).text();
                        try {
                            translation = literals[text][lang];
                        }
                        catch (err) {
                            //not found
                            translation = text;
                        }
                        $(this).text(translation);
                    });
                    $("[class^=FormFieldLayout__Hint] > div").each( function() {
                        text = $(this).text();
                        try {
                            translation = literals[text][lang];
                        }
                        catch (err) {
                            //not found
                            translation = text;
                        }
                        $(this).text(translation);
                    });
                    $("[class^=typography__Container-sc-]").each( function() {
                        if ($(this).children(). length === 0) {
                            text = $(this).text();
                            try {
                                translation = literals[text][lang];
                            }
                            catch (err) {
                                //not found
                                translation = text;
                            }
                            $(this).text(translation);
                        }
                    });
                    $("[class^=typography__Container-sc-] > div").each( function() {
                        text = $(this).html(); console.log(text);
                        try {
                            translation = literals[text][lang];
                        }
                        catch (err) {
                            //not found
                            translation = text;
                        }
                        $(this).replaceWith(translation);
                    });
                    $("span.animated-number__Content-sc-1xlvo88-0.lduKLf").each( function() {
                        var parts = $(this).text().split(" ");
                        if (parts.length > 1) {
                            text = parts[1];
                            try {
                                translation = literals[text][lang];
                            }
                            catch (err) {
                                //not found
                                translation = text;
                            }
                            setTimeout(
                                function() {
                                    $(this).text(parts[0] + " " + translation);
                                }, 2000, this
                            );
                        }
                    });
                    $("[class^=ButtonBase__Ellipsis-sc]").each( function() {
                        text = $(this).text();
                        try {
                            translation = literals[text][lang];
                        }
                        catch (err) {
                            //not found
                            translation = text;
                        }
                        $(this).text(translation);
                    });
                    if ($("span.variant-sku").text() === "ZVZX1320-S") {
                        $(".product-form__input.product-form__quantity label").each( function() {
                            text = $(this).text();
                            try {
                                translation = literals[text][lang];
                            }
                            catch (err) {
                                //not found
                                translation = text;
                            }
                            $(this).text(translation);
                        });
                        $("custom-fields .field-description").each( function() {
                            text = $(this).text().trim();
                            try {
                                translation = literals[text][lang];
                            }
                            catch (err) {
                                //not found
                                translation = text;
                            }
                            $(this).text(translation);
                        });
                        $("custom-fields label").each( function() {
                            text = $(this).text().trim().slice(0, -2).trim();
                            try {
                                translation = literals[text][lang];
                            }
                            catch (err) {
                                //not found
                                translation = text;
                            }
                            $(this).text(translation);
                        });

                    }
                },500,9000
            );
        };
        translateLiterals(".form__Container-sc-de90c04-0");

        var accHeader = document.getElementsByClassName("epdm-accordion-header");
        for (const key in accHeader) {
            if (accHeader.hasOwnProperty(key)) {
                accHeader[key].addEventListener("click", (evt) => translateLiterals(".form__Container-sc-de90c04-0"));
            }
        }
    }
});

function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
    var startTimeInMs = Date.now();
    (function loopSearch() {
        if (document.querySelector(selector) != null) {
            callback();
            return;
        }
        else {
            setTimeout(function () {
                if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
                    return;
                loopSearch();
            }, checkFrequencyInMs);
        }
    })();
}